import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Modal from "react-modal";
import moment from "moment";
import { DOC_BASE_URL, toastError } from "../../../../../utils/constants";
import VendorDetails from "../../vendorDetails";
class PlantAndBeautification extends Component {

  // Initilized Constructor 
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      is_View: false,
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      StatusID: "",
    };
  }

  componentDidMount() {

    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : false,
    });
  }



  render() {
    const { isLoading, is_View, isHideSection, DeadlineDate, currentDate } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="row p-2 exb-top-space">
              <div className="col-xl-12 p-1">
                <div className="card rounded-0 border shadow-none">
                  <div className="card-header p-2">
                    <h3 className="card-title">Plant And Beautification</h3>
                  </div>
                  <VendorDetails />
                  {!isHideSection && (
                    <div className="row mt-4">
                      <h6 className="mt-2 ">
                        Plant And Beautification{" "}
                        <span className="text-danger">
                          {" "}
                          Last Date Of Submission -{" "}
                          {this.props.location?.state?.ActualDeadline
                            ? moment(this.props.location.state.ActualDeadline).format(
                              "DD-MM-YYYY"
                            )
                            : "-"}
                        </span>
                      </h6>
                    </div>
                  )}
                  <div className="card-body p-2">
                    <div className="row">
                      <div className="col-xl-12 p-0">
                        <div className="card rounded-0 p-3">
                          <div className="card-body p-1">
                            <iframe
                              id="myIframe"
                              // src={`/${sessionStorage.getItem("sessionExhibitionID")}/Rules-and-Regulations.pdf#toolbar=0&navpanes=0`}
                              // src={`https://ems_uat.india-itme.com${FurnitureDetailsFilePath}`}
                              src={
                                DOC_BASE_URL +
                                "/document/ManualForm/PlantAndBeautification/PlantAndBeautification.png"
                              }
                              width="100%"
                              style={{ height: "600px" }}
                              title="Bing"
                            >
                              &lt;/div&gt; &lt;div style="height: 200px;"&gt;&lt;/div&gt;
                              &lt;/div&gt; &lt;/div&gt; &lt;/div&gt;
                            </iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(connect(null, {})(PlantAndBeautification))
